import { render, staticRenderFns } from "./BannerRefont.vue?vue&type=template&id=625e7800&scoped=true"
import script from "./BannerRefont.vue?vue&type=script&lang=js"
export * from "./BannerRefont.vue?vue&type=script&lang=js"
import style0 from "./BannerRefont.vue?vue&type=style&index=0&id=625e7800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e7800",
  null
  
)

export default component.exports